import React, { useContext, useEffect, useState } from "react";
import PreApprovalPanel from "./ClientPanels/PreApprovalPanel";
import { AppContext } from "../../../AppContext";
import "./Clients.css";
import PendingPanel from "./ClientPanels/PendingPanel";
import FilterModal from "./ClientModals/FilterModal";

const Clients = ({ device }) => {
  const {
    matrixData,
    userType,
    path,
    clientSelection,
    setClientSelection,
    teamMemberSelected,
    loFilter,
    setLoFilter,
    pendingClientFilter,
    setPendingClientFilter,
    preapprovedClientFilter,
    setPreapprovedClientFilter,
    agentFilter,
    setAgentFilter,
    loPreapprovedFilter,
    setLoPreapprovedFilter,
    agentPreapprovedFilter,
    setAgentPreapprovedFilter,
  } = useContext(AppContext);

  const [pendingClientFiltered, setPendingClientFiltered] =
    useState("All Clients");
  const [loFiltered, setLoFiltered] = useState("All Loan Officers");
  const [preapprovedClientFiltered, setPreapprovedClientFiltered] =
    useState("All Clients");
  const [agentFiltered, setAgentFiltered] = useState("All Agents");

  const [previousTeamMemberSelected, setPreviousTeamMemberSelected] = useState(teamMemberSelected)

  useEffect(()=>{
    if(teamMemberSelected !== previousTeamMemberSelected){
      setPendingClientFiltered("All Clients");
      setLoFiltered("All Loan Officers");
      setPreapprovedClientFiltered("All Clients");
      setAgentFiltered("All Agents");
    }
    setPreviousTeamMemberSelected(teamMemberSelected);
  },[teamMemberSelected])

  useEffect(() => {
    setTimeout(() => {
      if (path == "/pending") {
        setClientSelection("Pending");
      } else if (path == "/preapproved") {
        setClientSelection("Pre Approved");
      }
    }, 0);
  }, []);

  const clientTypeSelector = (
    <div className="clientTypeSelect">
      <div
        className={
          clientSelection === "Pending" ? `clientType selected` : "clientType"
        }
        onClick={() => {
          setClientSelection("Pending");
        }}
      >
        Pending
      </div>
      <div
        className={
          clientSelection === "Pre Approved"
            ? `clientType selected`
            : "clientType"
        }
        onClick={() => {
          setClientSelection("Pre Approved");
        }}
      >
        Pre Approved
      </div>
    </div>
  );

  const dataAvailable = () => {
    if (matrixData[0].Request === "No Request") {
      return false;
    } else {
      return true;
    }
  };

  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  let clientDataSorted = [];
  let preApprovedClients = [];
  let pendingClients = [];

  let loOptions = [];
  let loOptionsPreapproved = [];
  let pendingClientOptions = [];
  let preapprovedClientOptions = [];
  let agentOptions = [];
  let agentOptionsPreapproved = [];

  if (dataAvailable()) {
    const clientData = JSON.parse(matrixData[0]["Clients"]);
    clientDataSorted = clientData.sort((a, b) => {
      if (a["Name"] > b["Name"]) {
        return 1;
      } else {
        return -1;
      }
    });

    //Create arrays of Pending, Pre Approved, and Past Clients
    preApprovedClients = clientDataSorted.filter((e) => {
      return e.MtgPlanner_CRM__Stage__c === "Pre-Approved";
    });

    pendingClients = clientDataSorted.filter((e) => {
      return (
        e.MtgPlanner_CRM__Stage__c === "New Lead" ||
        e.MtgPlanner_CRM__Stage__c === "Attempting Contact" ||
        e.MtgPlanner_CRM__Stage__c === "Appointment Scheduled" ||
        e.MtgPlanner_CRM__Stage__c === "Application Sent" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Requested" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Received"
      );
    });
  }

  //Create formula to filter through lists
  const filteredOptions = ({
    fieldSelected,
    placeholder,
    setDisplay,
    setSelection,
    selection,
    clientArray,
    clientsFiltered,
  }) => {
    const pendingClientNames = clientArray
      .filter((e) => {
        if (clientsFiltered == "All Clients" || fieldSelected == "Name") {
          return e;
        } else {
          return e.Name == clientsFiltered;
        }
      })
      .filter((e) => {
        if (
          loFiltered == "All Loan Officers" ||
          fieldSelected == "Loan_Officer_Name__c"
        ) {
          return e;
        } else {
          return e.Loan_Officer_Name__c == loFiltered;
        }
      })
      .filter((e) => {
        if (
          agentFiltered == "All Agents" ||
          fieldSelected == "Agent_Contact_Name__c"
        ) {
          return e;
        } else {
          return e.Agent_Contact_Name__c == agentFiltered;
        }
      })
      .map((e) => e[fieldSelected])
      .filter(onlyUnique)
      .sort();

    const optionsList = pendingClientNames.map((e, index) => {
      return (
        <li
          className={`ClientRow ${selection == e ? "grey" : null}`}
          onClick={() => {
            setDisplay("hidden");
            setSelection(e);
          }}
          key={Math.random()}
        >
          <div className="name">{e}</div>
        </li>
      );
    });
    optionsList.unshift(
      <div key={Math.random()}>
        <li
          className={`ClientRow ${
            selection == "All Clients" ||
            selection == "All Loan Officers" ||
            selection == "All Agents"
              ? "grey"
              : null
          }`}
          onClick={() => {
            setDisplay("hidden");
            setSelection(placeholder);
          }}
        >
          <div className="name">{placeholder}</div>
        </li>
        <div className="tenPx"></div>
        <div className="dotted-hr"></div>
      </div>
    );

    return optionsList;
  };

  //Create panels of Pending, Pre Approved, and Past Clients

  let preApprovalPanels = [];

  if (dataAvailable()) {
    if (preApprovedClients[0] === undefined) {
      preApprovalPanels = (
        <>
          <div className="loading" key={Math.random()}>
            No current clients out shopping. Please let your loan officer know
            if you have any!
          </div>
        </>
      );
    } else {
      preApprovalPanels = preApprovedClients
        .filter((e) => {
          if (preapprovedClientFiltered == "All Clients") {
            return e;
          } else {
            return e.Name == preapprovedClientFiltered;
          }
        })
        .filter((e) => {
          if (loFiltered == "All Loan Officers") {
            return e;
          } else {
            return e.Loan_Officer_Name__c == loFiltered;
          }
        })
        .filter((e) => {
          if (agentFiltered == "All Agents") {
            return e;
          } else {
            return e.Agent_Contact_Name__c == agentFiltered;
          }
        })
        .map((e, index) => {
          let preApprovalDateFormatted = "TBD";
          if (e.Pre_Approval_Date__c) {
            const rawPreApprovalDate = new Date(
              e.Pre_Approval_Date__c.toString()
            );
            preApprovalDateFormatted =
              rawPreApprovalDate.getMonth() +
              1 +
              "/" +
              rawPreApprovalDate.getDate() +
              "/" +
              rawPreApprovalDate.getFullYear().toString().substring(2, 4);
          }

          return (
            <PreApprovalPanel
              key={index}
              index={index}
              clientName={e.Name}
              loanOfficerName={e.Loan_Officer_Name__c}
              loanOfficerEmail={e.Loan_Officer_Email__c}
              loanOfficerPhone={e.Loan_Officer_Phone__c}
              agentPartner={e.Agent_Contact_Name__c}
              agentEmail={e.Agent_Contact_Email__c}
              preApprovalAmt={e.Max_Pre_Approval__c}
              preApprovalDate={preApprovalDateFormatted}
              floifyId={e.Floify_ID__c}
              downpaymentPercentage={e.Downpayment__c}
              downpaymentDollar={e.Preapproval_Downpayment__c}
              loanProgram={e.Loan_Program__c}
              googleTemplateID={e.LO_Pre_Approval_Template_ID__c}
              googleFolderId={e.LO_Pre_Approval_Folder_ID__c}
              preApprovalNames={e.Name_s_on_Letter__c}
              loNotes={e.Matrix_App_Notes__c}
              agentNotes={e.Agent_Notes_via_App__c}
              id={e.Id}
              coAgentName={e.Co_Agent_Contact_Name__c}
              agentPhone={e.Agent_Contact_Phone__c}
              coAgentPhone={e.Co_Agent_Contact_Phone__c}
              loanOfficerTextNotifications={
                !e.Loan_Officer_Text_Notifications_Off__c
              }
              agentTextNotifications={
                !e.Agent_Contact_Text_Notifications_Off__c
              }
              coAgentTextNotifications={
                !e.Co_Agent_Contact_Text_Notifications_Off__c
              }
            />
          );
        });

      preapprovedClientOptions = filteredOptions({
        fieldSelected: "Name",
        placeholder: "All Clients",
        setDisplay: setPreapprovedClientFilter,
        setSelection: setPreapprovedClientFiltered,
        selection: preapprovedClientFiltered,
        clientArray: preApprovedClients,
        clientsFiltered: preapprovedClientFiltered,
      });
      loOptionsPreapproved = filteredOptions({
        fieldSelected: "Loan_Officer_Name__c",
        placeholder: "All Loan Officers",
        setDisplay: setLoPreapprovedFilter,
        setSelection: setLoFiltered,
        selection: loFiltered,
        clientArray: preApprovedClients,
        clientsFiltered: preapprovedClientFiltered,
      });
      agentOptionsPreapproved = filteredOptions({
        fieldSelected: "Agent_Contact_Name__c",
        placeholder: "All Agents",
        setDisplay: setAgentPreapprovedFilter,
        setSelection: setAgentFiltered,
        selection: agentFiltered,
        clientArray: preApprovedClients,
        clientsFiltered: preapprovedClientFiltered,
      });

      preApprovalPanels.unshift(
        <div className="filters" key={`preapproval default`}>
          {userType == "Loan Officer" ? null : (
            <div
              className={`filter-panel ${
                loFiltered === "All Loan Officers" ? "noFilterText" : null
              }`}
              onClick={() => {
                setLoPreapprovedFilter("");
              }}
            >
              {loFiltered}
            </div>
          )}
          {userType == "Agent" ? null : (
            <div
              className={`filter-panel ${
                agentFiltered === "All Agents" ? "noFilterText" : null
              }`}
              onClick={() => {
                setAgentPreapprovedFilter("");
              }}
            >
              {agentFiltered}
            </div>
          )}
          <div
            className={`filter-panel ${
              preapprovedClientFiltered === "All Clients"
                ? "noFilterText"
                : null
            }`}
            onClick={() => {
              setPreapprovedClientFilter("");
            }}
          >
            {preapprovedClientFiltered}
          </div>
        </div>
      );
      preApprovalPanels.push(
        <span className="disclaimer" key={Math.random()}>
          Matrix displays actively engaged clients only. Still think a client is
          missing? Check with your Loan Officer.
        </span>
      );
    }
  }

  let pendingPanels = [];

  if (dataAvailable()) {
    if (pendingClients[0] === undefined) {
      pendingPanels = (
        <>
          <div className="loading">
            No current clients out shopping. Please let your loan officer know
            if you have any!
          </div>
        </>
      );
    } else {
      pendingPanels = pendingClients
        .filter((e) => {
          if (pendingClientFiltered == "All Clients") {
            return e;
          } else {
            return e.Name == pendingClientFiltered;
          }
        })
        .filter((e) => {
          if (loFiltered == "All Loan Officers") {
            return e;
          } else {
            return e.Loan_Officer_Name__c == loFiltered;
          }
        })
        .filter((e) => {
          if (agentFiltered == "All Agents") {
            return e;
          } else {
            return e.Agent_Contact_Name__c == agentFiltered;
          }
        })
        .map((e, index) => {
          return (
            <PendingPanel
              key={index}
              index={index}
              clientName={e.Name}
              loanOfficerName={e.Loan_Officer_Name__c}
              loanOfficerEmail={e.Loan_Officer_Email__c}
              loanOfficerPhone={e.Loan_Officer_Phone__c}
              agentPartner={e.Agent_Contact_Name__c}
              agentEmail={e.Agent_Contact_Email__c}
              floifyId={e.Floify_ID__c}
              stage={e.MtgPlanner_CRM__Stage__c}
              loNotes={e.Matrix_App_Notes__c}
              agentNotes={e.Agent_Notes_via_App__c}
              id={e.Id}
              coAgentName={e.Co_Agent_Contact_Name__c}
              agentPhone={e.Agent_Contact_Phone__c}
              coAgentPhone={e.Co_Agent_Contact_Phone__c}
              loanOfficerTextNotifications={
                !e.Loan_Officer_Text_Notifications_Off__c
              }
              agentTextNotifications={
                !e.Agent_Contact_Text_Notifications_Off__c
              }
              coAgentTextNotifications={
                !e.Co_Agent_Contact_Text_Notifications_Off__c
              }
            />
          );
        });

      pendingClientOptions = filteredOptions({
        fieldSelected: "Name",
        placeholder: "All Clients",
        setDisplay: setPendingClientFilter,
        setSelection: setPendingClientFiltered,
        selection: pendingClientFiltered,
        clientArray: pendingClients,
        clientsFiltered: pendingClientFiltered,
      });
      loOptions = filteredOptions({
        fieldSelected: "Loan_Officer_Name__c",
        placeholder: "All Loan Officers",
        setDisplay: setLoFilter,
        setSelection: setLoFiltered,
        selection: loFiltered,
        clientArray: pendingClients,
        clientsFiltered: pendingClientFiltered,
      });
      agentOptions = filteredOptions({
        fieldSelected: "Agent_Contact_Name__c",
        placeholder: "All Agents",
        setDisplay: setAgentFilter,
        setSelection: setAgentFiltered,
        selection: agentFiltered,
        clientArray: pendingClients,
        clientsFiltered: pendingClientFiltered,
      });

      pendingPanels.unshift(
        <div className="filters" key={`preapproval default`}>
          {userType == "Loan Officer" ? null : (
            <div
              className={`filter-panel ${
                loFiltered === "All Loan Officers" ? "noFilterText" : null
              }`}
              onClick={() => {
                setLoFilter("");
              }}
            >
              {loFiltered}
            </div>
          )}
          {userType == "Agent" ? null : (
            <div
              className={`filter-panel ${
                agentFiltered === "All Agents" ? "noFilterText" : null
              }`}
              onClick={() => {
                setAgentFilter("");
              }}
            >
              {agentFiltered}
            </div>
          )}
          <div
            className={`filter-panel ${
              pendingClientFiltered === "All Clients" ? "noFilterText" : null
            }`}
            onClick={() => {
              setPendingClientFilter("");
            }}
          >
            {pendingClientFiltered}
          </div>
        </div>
      );
      pendingPanels.push(
        <span className="disclaimer" key={Math.random()}>
          Matrix displays actively engaged clients only. Still think a client is
          missing? Check with your Loan Officer.
        </span>
      );
    }
  }

  const displayClientPanels = (
    <>
      <div className="clientsTopBar">
      </div>
      {clientSelection === "Pre Approved" ? preApprovalPanels : null}
      {clientSelection === "Pending" ? pendingPanels : null}
    </>
  );

  return (
    <>
      <div className={`Application-tab Clients ${device}`}>
        {dataAvailable() ? (
          <>
            <div className="fullWidth tenPx"></div>
            {displayClientPanels}
            <div className="twentyFivePx"></div>
            <div className="twentyFivePx"></div>
          </>
        ) : (
          <div className="loading">Click "Account" to login :)</div>
        )}
        <FilterModal
          options={loOptions}
          visible={loFilter}
          setFilter={setLoFilter}
        />
        <FilterModal
          options={agentOptions}
          visible={agentFilter}
          setFilter={setAgentFilter}
        />
        <FilterModal
          options={loOptionsPreapproved}
          visible={loPreapprovedFilter}
          setFilter={setLoPreapprovedFilter}
        />
        <FilterModal
          options={agentOptionsPreapproved}
          visible={agentPreapprovedFilter}
          setFilter={setAgentPreapprovedFilter}
        />
        <FilterModal
          options={pendingClientOptions}
          visible={pendingClientFilter}
          setFilter={setPendingClientFilter}
        />
        <FilterModal
          options={preapprovedClientOptions}
          visible={preapprovedClientFilter}
          setFilter={setPreapprovedClientFilter}
        />
      </div>
    </>
  );
};

export default Clients;
